import React, {Component} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from   '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import OKIcon from '@material-ui/icons/CheckCircleOutlined';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },

  
  zoomSize: {
	width: '85%',
	height: '85%',
	margin: 100,
  },
  
  regularSize: {
	width: '40%',
	height: '40%',
	margin: 200,
  },

  content: {
	backgroundColor: 'white',
	opacity: '1',
  },
  
});

class ViewCheckPopup extends Component {
	constructor(props) {
		super(props);
		this.handleClose = this.handleClose.bind(this);
    }

  handleClose(e){
	e.preventDefault();
	 this.props.onClosePopup(e);
  }

  render() {
    const { classes } = this.props;
		let { t } = this.props;
    return (
	<div >
		{this.props.regular &&
			<Dialog className={classes.regularSize}
			open 
			fullScreen={true} 
      onClose={this.handleClose}
			PaperProps ={{
				classes: {
				root: classes.content
				}
			}}
			>
			<DialogTitle >{t('checkImage.label')}</DialogTitle>
			<DialogContent>
				<img hspace='20' width='1536' height='657' border='1'  src={this.props.url} alt='Not Available'/>
			</DialogContent>
			<DialogActions style={{display: 'flex', justifyContent: 'center'}}>
			  <Button  color='primary' onClick={this.handleClose} >
				<OKIcon/>&nbsp;{t('ok.button')}
			  </Button>
			</DialogActions>
		  </Dialog>
		}	
		{this.props.zoom &&
			<Dialog className={classes.zoomSize}
			open 
			fullScreen={true} 
            onClose={this.handleClose}
			PaperProps ={{
				classes: {
				root: classes.content
				}
			}}
			>
			<DialogTitle >{t('checkImage.label')}</DialogTitle>
			<DialogContent>
				<img hspace='20' width='1536' height='657' border='1'  src={this.props.url} alt='Not Available'/>
			</DialogContent>
			<DialogActions style={{display: 'flex', justifyContent: 'center'}}>
			  <Button  color='primary' onClick={this.handleClose} >
				<OKIcon/>&nbsp;{t('ok.button')}
			  </Button>
			</DialogActions>
		  </Dialog>
		}
    </div>
    );
  }  
	
}
export default  withTranslation()(withStyles(styles)(ViewCheckPopup));  
